import type { ConnectionDisplayMode } from '../../../core/ports/preferences-repository';
import { useLocale } from '../i18n/LocaleProvider';

export function ConnectionDisplayModeSwitcher({
	connectionDisplayMode,
	onChange,
}: {
	connectionDisplayMode: ConnectionDisplayMode;
	onChange: (connectionDisplayMode: ConnectionDisplayMode) => void;
}) {
	const { t } = useLocale();

	return (
		<label style={{ display: 'grid', gap: 6 }}>
			<span>{t('connectionDisplayMode')}</span>
			<select
				className="hud-input"
				aria-label={t('connectionDisplayMode')}
				value={connectionDisplayMode}
				onChange={(event) => onChange(event.target.value as ConnectionDisplayMode)}
			>
				<option value="all">{t('connectionDisplayModeAll')}</option>
				<option value="tag-derived">{t('connectionDisplayModeTagDerived')}</option>
				<option value="explicit-only">{t('connectionDisplayModeExplicitOnly')}</option>
				<option value="tag-derived-focus">{t('connectionDisplayModeTagDerivedFocus')}</option>
			</select>
		</label>
	);
}
